import { supabase } from './supabase.js';
import { getPublicSiteBase } from '../constants/siteConfig.js';
import { resolveAdminInvokeError } from './adminActionsInvoke.js';

/**
 * Construye el kit de redes (textos, URL, imágenes) vía admin-actions.
 * @param {{ content_type: string, content_id: string }} params
 */
export async function fetchSocialKit(params) {
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: {
      action: 'social_build_kit',
      payload: {
        content_type: params.content_type,
        content_id: params.content_id,
        site_base: getPublicSiteBase(),
      },
    },
  });
  const serverMsg = data && typeof data === 'object' && data.message != null ? String(data.message) : '';
  if (error) {
    return { ok: false, error: serverMsg || error.message || 'No se pudo generar el kit.' };
  }
  if (!data?.ok || !data.kit) {
    return { ok: false, error: serverMsg || data?.error || 'Respuesta inválida del servidor.' };
  }
  return { ok: true, kit: data.kit, publications: data.publications ?? [] };
}

/**
 * Envía publicación a n8n para una red concreta.
 * @param {{ content_type: string, content_id: string, network: string }} params
 */
export async function publishSocialToN8n(params) {
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: {
      action: 'social_publish',
      payload: {
        content_type: params.content_type,
        content_id: params.content_id,
        network: params.network,
        site_base: getPublicSiteBase(),
      },
    },
  });
  const serverMsg = data && typeof data === 'object' && data.message != null ? String(data.message) : '';
  if (error) {
    return { ok: false, error: serverMsg || error.message || 'No se pudo enviar a n8n.' };
  }
  if (!data?.ok) {
    return { ok: false, error: serverMsg || data?.error || 'Publicación rechazada.' };
  }
  return { ok: true, post_url: data.post_url ?? null, network: data.network };
}

/** Encola publicación en redes (admin; `source=admin` ignora auto_enqueue desactivado). */
export async function enqueueSocialPublish(contentType, contentId) {
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: {
      action: 'social_enqueue',
      payload: { content_type: contentType, content_id: contentId },
    },
  });
  const serverMsg = data && typeof data === 'object' && data.message != null ? String(data.message) : '';
  if (error) return { ok: false, error: serverMsg || error.message || 'No se pudo encolar.' };
  if (!data?.ok) return { ok: false, error: serverMsg || data?.error || 'Encolado rechazado.' };
  return { ok: true, queue_id: data.queue_id ?? null };
}

/** Procesa la cola pendiente o con error (admin o tras publicar). */
export async function processSocialQueue(limit = 5) {
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: { action: 'social_process_queue', payload: { limit } },
  });
  if (error || !data?.ok) {
    const msg = await resolveAdminInvokeError(error, data, 'No se pudo procesar la cola.');
    return { ok: false, error: msg };
  }
  return { ok: true, processed: data.processed, results: data.results ?? [] };
}

/** Registra URL devuelta por n8n (callback manual si el workflow publica fuera del webhook sync). */
export async function recordSocialPublication(params) {
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: {
      action: 'social_record_publication',
      payload: {
        content_type: params.content_type,
        content_id: params.content_id,
        network: params.network,
        post_url: params.post_url,
        queue_id: params.queue_id ?? null,
      },
    },
  });
  const serverMsg = data && typeof data === 'object' && data.message != null ? String(data.message) : '';
  if (error) return { ok: false, error: serverMsg || error.message };
  if (!data?.ok) return { ok: false, error: serverMsg || 'No se guardó la publicación.' };
  return { ok: true };
}
